import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { api } from "../data";

/**
 * Anwesenheit je Agentur und Seite melden (0048): beim ersten Aufruf der Sitzung als Anmeldung, danach höchstens einmal je Minute
 * beim Seitenwechsel. Fehler bleiben still, die Anzeige „zuletzt im Portal“ ist ein Hinweis, kein Protokoll.
 */
export function usePresencePing(orgId: string, side: "staff" | "creator") {
  const location = useLocation();
  const last = useRef(0);
  useEffect(() => {
    const now = Date.now();
    if (now - last.current < 60_000) return;
    last.current = now;
    const key = `tk-presence-login:${side}:${orgId}`;
    let login = false;
    try {
      login = !sessionStorage.getItem(key);
      if (login) sessionStorage.setItem(key, "1");
    } catch {
      login = false;
    }
    const view = location.pathname.split("/").filter(Boolean).slice(0, 2).join("/") || "start";
    void api.read("presence_ping_org", { p_org: orgId, p_side: side, p_view: view, p_login: login }).catch(() => undefined);
  }, [orgId, side, location.pathname]);
}
